import CommunityInfoCard from './CommunitiesInfoCard';

export default CommunityInfoCard;
